import routerOptions0 from "/home/yuyue/Documents/embbay/node_modules/.pnpm/nuxt@3.8.2_@types+node@18.18.13_typescript@5.2.2_vite@4.5.2/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}